<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 24 24">
    <g transform="translate(7118 5917)">
      <g transform="translate(-7115.5 -5916)">
        <path d="M1.5,11.5S4.409,6,9.5,6s8,5.5,8,5.5S14.591,17,9.5,17,1.5,11.5,1.5,11.5Z" fill="none" :stroke="props.colorFill" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
        <path d="M17.864,15.563A2.185,2.185,0,1,1,15.682,13.5,2.125,2.125,0,0,1,17.864,15.563Z" transform="translate(-6.182 -4.063)" fill="none" :stroke="props.colorFill" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconEye',

  props: {
    size: { type: [String, Number], default: '24px' },
    colorFill: { type: String, default: '#d6001b' },
  }
}
</script>